export default __webpack_public_path__ + "static/media/edit.f7b5b294.svg";